import { useEffect, useState, useCallback } from "react";
import Marquee from "react-fast-marquee";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";
import useSize from "../../../../Utils/useSize/useSize";

const backend = await new Backend().init();

export default function MarqueeComponent() {
  const windowSize = useSize();
  const [marquee, setMarquee] = useState("");

  /** ✅ Load Marquee Text */
  const loadMarquee = useCallback(async () => {
    try {
      const data = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
      };

      const r = await backend.marquee(data);

      if (r.error === "False") setMarquee(r.marquee.text || "");
      else toast.error(r.message);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load marquee.");
    }
  }, []);

  /** ⏳ Load marquee on mount */
  useEffect(() => {
    loadMarquee();
  }, [loadMarquee]);

  return (
    <div className="h-[20px] bg-[var(--background)] cursor-pointer select-none">
      <Marquee
        speed={50}
        pauseOnHover
        gradient={false}
        style={{
          width: windowSize[0],
        }}
        className="font-semibold text-[var(--text)] large text-base px-3"
      >
        {marquee || "No marquee text available"}
      </Marquee>
    </div>
  );
}
